<div class="c-page-cardissuanceapprover"></div>
<div class="container u-pb30" *ngIf="card">
    <div class="row mobile--orange u-pt40">
        <div class="col-md-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a> {{'CardApproverDetailsPortal.home'| translate}}</a></li>
                    <li class="breadcrumb-item active" aria-current="page" [routerLink]="['/card-approver/list']">- <a>{{'CardApproverDetailsPortal.level2'| translate}}</a></li>
                    <li class="breadcrumb-item active" aria-current="page">- <span>{{'CardApproverDetailsPortal.location'| translate}}</span></li>
                </ol>
            </nav>
            <h2 class="o-title " *ngIf="card.type">{{'CardApproverDetailsPortal.newCardTitle'|translate}} {{card.requestNumber}} </h2>
            <h2 class="o-title " *ngIf="!card.type">{{'CardApproverDetailsPortal.cardReplacementTitle'|translate}} {{card.requestNumber}} </h2>
        </div>
    </div>
    <div class="row u-pt30">
        <div class="col-md-12">
            <div class="c-card c-card--small">
                <div class="row">
                    <div class="col-md-4">
                        <p> <strong>{{'CardApproverDetailsPortal.labelCardRequestor'|translate}}:</strong> {{card.requester.name}}</p>
                    </div>
                    <div class="col-md-4">
                        <p> <strong>{{'CardApproverDetailsPortal.labelJobTitle'|translate}}:</strong> {{card.requester.jobTitle}}</p>
                    </div>
                    <div class="col-md-4">
                        <p> <strong>{{'CardApproverDetailsPortal.labelEmail'|translate}}:</strong> {{card.requester.email}} </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 u-pt30">
            <h2 class="o-title o-title--medium"><span>{{'CardApproverDetailsPortal.labelStatus'|translate}}: </span>
                <strong class="gray" *ngIf="card.status.id===1" >{{'CardApproverDetailsPortal.statusPending'|translate}}</strong>
                <strong class="gray" *ngIf="card.status.id===2" >{{'CardApproverDetailsPortal.statusClose'|translate}}</strong>
            </h2>
        </div>
        <div class="col-md-12 u-pt20">
            <div class="u-pb20">
                <h2 class="o-title o-title--medium o-title--orange"> {{'CardApproverDetailsPortal.detailTitle'|translate}}  </h2>
            </div>
            <div class="row">
                <div class="col-md-3 col-lg-2" *ngIf="!card.type">
                    <p class="o-text u-pb0"> <strong>{{'CardApproverDetailsPortal.labelMotive'|translate}}</strong></p>
                    <p class="o-text" *ngIf="getlang()==='en'">{{card.motive.name}}</p>
                    <p class="o-text" *ngIf="getlang()==='es'">{{card.motive.nameEs}}</p>
                </div>
                <div class="col-md-3 col-lg-2">
                    <p class="o-text u-pb0"> <strong>{{'CardApproverDetailsPortal.labelPlaceEmployee'|translate}}</strong></p>
                    <p class="o-text">{{card.site.name}}</p>
                </div>
                <div class="col-md-3">
                    <p class="o-text u-pb0"> <strong>{{'CardApproverDetailsPortal.labelPickUpPlace'|translate}}</strong></p>
                    <p class="o-text" *ngIf="getlang()==='en'">{{card.pickupPlace.name}} </p>
                    <p class="o-text" *ngIf="getlang()==='es'">{{card.pickupPlace.nameEs}} </p>
                </div>
            </div>
            <hr class="big">
        </div>
        <div class="col-md-12">
            <h2 class="o-title o-title--medium o-title--orange">{{'CardApproverDetailsPortal.infoTitle'|translate}} </h2>
        </div>
        <div class="col-md-12 u-pt30">
            <table class="table table--clean">
                <thead>
                    <tr>
                        <th>{{'CardApproverDetailsPortal.colNumber'|translate}}</th>
                        <th>{{'CardApproverDetailsPortal.colType'|translate}}</th>
                        <th>{{'CardApproverDetailsPortal.colRutPassport'|translate}}</th>
                        <th>{{'CardApproverDetailsPortal.colFullName'|translate}}</th>
                        <th>{{'CardApproverDetailsPortal.colEmail'|translate}}</th>
                        <th>{{'CardApproverDetailsPortal.colCompanyName'|translate}}</th>
                        <th>{{'CardApproverDetailsPortal.colEmployeeType'|translate}}</th>
                        <th>{{'CardApproverDetailsPortal.colImage'|translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let person of card.peoples; index as i">
                        <td class="table__number">
                            <p class="green">{{i+1}} </p>
                        </td>
                        <td>
                            <p><span *ngIf="person.passportNumber" >{{'CardApproverDetailsPortal.passport'|translate}}</span><span *ngIf="person.passportNumber && person.nationalId"> / </span>
                                 <span *ngIf="person.nationalId" >{{'CardApproverDetailsPortal.rut'|translate}}</span></p>
                        </td>
                        <td>
                            <p><span *ngIf="person.passportNumber" >{{person.passportNumber}}</span><span *ngIf="person.passportNumber && person.nationalId"> / </span> <span *ngIf="person.nationalId" >{{person.nationalId}}</span></p>
                        </td>
                        <td>
                            <p>{{person.firstName}} {{person.lastName}}</p>
                        </td>
                        <td>
                            <p>{{person.email}}</p>
                        </td>
                     
                        <td>
                            <p *ngIf="person.personnelArea === '1'">{{'CardApproverDetailsPortal.optMel'|translate}}</p>
                            <p *ngIf="person.personnelArea === '2'">{{'CardApproverDetailsPortal.optSpence'|translate}}</p>
                            <p *ngIf="person.personnelArea === '3'">{{'CardApproverDetailsPortal.optBHPChile'|translate}}</p>
                        </td>
                        <td>
                            <p>{{person.employeeType}}</p>
                        </td>
                        <td>
                           
                            <div *ngIf="person.imageUpload" (click)="downloadOneImage(card.requestNumber, person.mdmid, person)">
                                <img style="max-width: 20px; cursor: pointer;" src="../assets/img/icn/ICONO/download.svg" alt="" >
                            </div> 
                             <div *ngIf="!person.imageUpload"  style="opacity:30%">
                                <img style="max-width: 20px; " src="../assets/img/icn/ICONO/download.svg" alt="" >
                            </div> 
                         
                    </td>
                    </tr>

                </tbody>
            </table>

             <div class="col-md-12 u-pt50">
                <div *ngIf="isReposition" style="width:100%; background-color: #F2F0E9" align="center">
                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-warning"></i>  {{'CardApproverDetailsPortal.warnReplacement' | translate}}</mat-error></h5></span>
                </div>
                <button *ngIf="alldownloadEnabled" (click)= "downloadAllimages(card)"class="btn btn--primary">{{'CardApproverDetailsPortal.btnPhoto'|translate}}</button>
                <button *ngIf="!alldownloadEnabled" style="opacity:30%" class="btn btn--primary" disabled>{{'CardApproverDetailsPortal.btnPhoto'|translate}}</button>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="card.status.name!='Closed' || card.status.name==='Pending' ">
        <form class="o-form" [formGroup]="formNewcard" (ngSubmit)="onSubmit()">
            <div class="col-md-12 u-pt80">

                <!-- <div class="o-form__checkbox u-mb20">
                    <input type="checkbox" name="checkbox2" formControlName="Confirm" value="value"><span></span><a class="open_modal" (click)="openDialogTerm()" data="terms"></a>
                </div>
                <mat-error *ngIf="!formNewcard.controls['Confirm'].value && submited"> {{ 'validations.sel1' | translate}} </mat-error> -->
            </div>
            <div class="col-md-12 u-pt50">
                <a class="btn open_modal" [routerLink]="['/card-approver/list']" data="mod-can-req">{{'CardApproverDetailsPortal.btnBack'|translate}}</a>
                <button class="btn btn--primary">{{'CardApproverDetailsPortal.btnCloseOrder'|translate}}</button>
            </div>
        </form>
    </div>
</div>

<ngx-spinner name="closeOrder" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-grid-beat">
    <p style="font-size: 20px; color: white">{{'spinners.loading'|translate}}...</p>
</ngx-spinner>